import { BillingVersion } from 'common/billing/constants/AccountBillingInfo'
import { ProInfo, ProInfoProducts } from 'common/billing/entities/pro/interfaces'
import { BillingProSettings, Products } from 'shared/api/requests/billing/schemas'

import { convertPrice } from './convertPrice'
import { convertV3Products } from './convertV3Products'

export function convertPro(proSettings?: BillingProSettings): ProInfo {
  if (!proSettings || !Object.keys(proSettings).length) {
    return {}
  }

  const addOns = proSettings.addons_data.map((addOn) => convertPrice(addOn))
  if (!('products' in proSettings) || !proSettings.products) {
    return {
      ...proSettings,
      products: undefined,
      addons_data: addOns,
      scheduled_at: null,
      scheduled_plan: null,
      paywall_config: null,
      current_touched_contacts: 0,
    }
  }

  if (proSettings.billing_version === BillingVersion.V3) {
    const rawProducts = proSettings.paywall_config?.products ?? proSettings.products ?? {}
    const products = convertV3Products(rawProducts)

    return {
      ...proSettings,
      products,
      addons_data: addOns,
      paywall_billing_provider: proSettings.paywall_config?.billing_provider ?? null,
    }
  }

  const products: ProInfoProducts = Object.fromEntries(
    Object.entries(proSettings.products as Products)
      .filter(([, product]) => Boolean(product))
      .map(([slug, product]) => [slug, convertPrice(product)]),
  ) as unknown as ProInfoProducts

  return {
    ...proSettings,
    products,
    addons_data: addOns,
    scheduled_at: null,
    scheduled_plan: null,
    paywall_config: null,
    current_touched_contacts: proSettings.active_contacts ?? 0,
  }
}
